import type { FC, ReactText } from 'react';
import React from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';
import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';
import { customValidation } from '@alfa-bank/site-form-helpers/validation/custom-validation';

import type { TInput } from './models';
import { checkValue, getValidator, getPatternByType, getPrimitiveType } from './helpers';

/**
 * Инпут
 */
export const Input: FC<TInput> = ({
    BaseInput,
    Field,
    className,
    getCaption,
    isSuccess,
    isError,
    name,
    settings = {},
    size,
    isRequired,
    hideStatusIcon,
    validator,
    disabled = false,
    receivesFocus = true,
    dispatchesFocus = true,
    validatorConfig = [],
    dataTestId = 'form-input',
}) => {
    const inputValidator = isRequired ? 'required' : validator;

    return (
        <Field<string>
            data={{ settings }}
            dispatchesFocus={dispatchesFocus}
            name={name}
            receivesFocus={receivesFocus}
            render={({ input, meta }) => (
                <div className={className}>
                    <BaseInput
                        {...input}
                        caption={getCaption(meta, settings.caption)}
                        dataTestId={dataTestId}
                        disabled={disabled}
                        error={isError(meta)}
                        forwardedRef={actions.getRef(meta)}
                        hideStatusIcon={hideStatusIcon}
                        maxLength={settings.maxLength}
                        min={settings.min}
                        onBlur={({ event }) => {
                            input.onChange(event.target.value.trim());
                            input.onBlur(event);
                        }}
                        onChange={({ value }: { value: ReactText }) => {
                            const pattern = settings.accept || getPatternByType(settings.type);
                            const newValue = String(value);

                            if (checkValue(newValue, pattern)) {
                                actions.onChange(input)(newValue);
                            }
                        }}
                        onFocus={({ event }) => input.onFocus(event)}
                        placeholder={settings.placeholder}
                        size={size}
                        success={isSuccess(meta)}
                        type={getPrimitiveType(settings.type)}
                    />
                </div>
            )}
            validate={
                inputValidator
                    ? composeValidators(
                          getValidator(inputValidator)(),
                          customValidation(validatorConfig)
                      )
                    : undefined
            }
        />
    );
};
